module.exports = __webpack_public_path__ + "distribution/img/ico_fenxiang2.9dbcf716.png";